import { useState, useEffect } from 'react';
import { Region } from '../types/orderTypes';
import { Dayjs } from 'dayjs';
import { ReqEnum } from '../const/requestStatus';
import { DeliveryDetails, fetchAllDeliveries } from '../fetch/reportFetch';

export function useFetchDeliveries(
  startDate: Dayjs,
  endDate: Dayjs,
  region: Region = undefined
): [DeliveryDetails[], ReqEnum] {
  const [fetchStatus, setFetchStatus] = useState<ReqEnum>(ReqEnum.INIT);
  const [deliveries, setDeliveries] = useState<DeliveryDetails[]>([]);

  useEffect(() => {
    setFetchStatus(ReqEnum.PENDING);
    const fetchDeliveries = async () => {
      const deliveries = await fetchAllDeliveries(startDate, endDate, region);
      setDeliveries(deliveries);
      setFetchStatus(ReqEnum.SUCCESS);
    };
    fetchDeliveries();
  }, [startDate, endDate, region]);

  return [deliveries, fetchStatus];
}
